import { createAsyncAction } from 'typesafe-actions'
import { MessageState } from '../../types'
import { Failure, Request, Success } from './types'

export const deleteMessageAction = createAsyncAction(
  '@message/DELETE_MESSAGE_REQUEST',
  '@message/DELETE_MESSAGE_SUCCESS',
  '@message/DELETE_MESSAGE_FAILURE'
)<Request, Success, Failure>()

const request = (state: MessageState): MessageState => ({
  ...state,
  isLoadingOnDeleteMessage: true
})

const success = (state: MessageState): MessageState => {
  return {
    ...state,
    isSuccessOnDeleteMessage: true,
    isLoadingOnDeleteMessage: false
  }
}

const failure = (state: MessageState): MessageState => {
  return {
    ...state,
    isLoadingOnDeleteMessage: false,
    isErrorOnDeleteMessage: true
  }
}

export const deleteMessageHandle = {
  asyncAction: deleteMessageAction,
  request,
  success,
  failure
}
